import { Controller } from "@hotwired/stimulus"

// Automatically trims whitespace from email input fields on blur
export default class extends Controller {
  connect() {
    this.element.addEventListener("blur", this.trim.bind(this))
  }

  disconnect() {
    this.element.removeEventListener("blur", this.trim.bind(this))
  }

  trim() {
    this.element.value = this.element.value.trim()
  }
}
